<template>
  <div class="w100 px-5 px-sm-10 py-10 home-wrapper">
    <div class="row mx-md-10">
      <div class="col-lg-1 col-md-1"></div>
      <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12 container-text-home">
        <p class="font-white font-regular text-home">Bienvenido a Mobil Predictor, la experiencia de Mobil™ que te hará
          vivir cada carrera como nunca antes.
          Como socios tecnológicos de Oracle Red Bull Racing, llevamos toda la emoción y tecnología de la Fórmula 1™ a
          tus manos.
          <strong>Haz tus predicciones en cada carrera, suma puntos con cada acierto y escala posiciones en el tablero mientras
          demuestras que eres un verdadero experto o experta de la máxima categoría del automovilismo.</strong> </p>
      </div>
      <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
        <img class="image-home" src="../../../assets/2026/max_isack_home.png" alt="MaxRedBull2025" />
      </div>
      <div class="col-lg-1 col-md-1"></div>
    </div>
    <!-- <div class="mt-3 boton-empezar-mobile">
      <a href="/iniciar-sesion" class="home-button">
        Empezar
      </a>
    </div> -->
    <!-- <div class="home-powered-strip d-flex align-center justify-center">
      <p class="font-white text-home-brand italica mb-0">Powered by Mobil™ Racing Club</p>
    </div> -->
  </div>
</template>

<script src="./home.js" />
<style src="./home.scss" lang="scss" />
<script>
export default {
  mounted() {
    fbq('track', 'Traffic');
  },
}
</script>
